var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'form-v3-ecommerce': true, 'csr-account-form': true}},[(_setup.showPhoneNav)?_c('div',{staticClass:"csr-account-form__nav-title",on:{"click":() => _setup.clickCancel()}},[_c('div',{staticClass:"csr-account__back__icon"}),_vm._v(" "+_vm._s(_vm.config.address.title)+" ")]):_vm._e(),_c('form',{on:{"submit":function($event){$event.preventDefault();return _setup.submitForm.apply(null, arguments)}}},[_c('div',{staticClass:"csr-account-form__field"},[_c(_setup.FirstName,{ref:"firstNameInput",attrs:{"data-conf":{ 
            label: _vm.config.address.firstnameLabel, 
            placeholder: _vm.config.address.firstnamePlaceholder, 
            required: true,
            name: 'firstName',
            defaultValue: _vm.editAddress?.firstName,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}}),_c(_setup.LastName,{ref:"lastNameInput",attrs:{"data-conf":{ 
            label: _vm.config.address.lastnameLabel, 
            placeholder: _vm.config.address.lastnamePlaceholder, 
            required: true,
            name: 'lastName',
            defaultValue: _vm.editAddress?.lastName,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}})],1),_c(_setup.Address,{ref:"addressInput",attrs:{"id":"maps-autocomplete","data-conf":{ 
          label: _vm.config.address.addressLabel, 
          placeholder: _vm.config.address.addressPlaceholder, 
          required: true,
          name: 'address1',
          defaultValue: _vm.editAddress?.address1,
          defErrorMsg: _vm.config.requiredFieldsPrompt,
        }}}),(_vm.config?.address?.address2Label)?_c(_setup.Address,{ref:"address2Input",attrs:{"data-conf":{ 
          label: _vm.config?.address?.address2Label, 
          placeholder: _vm.config?.address?.address2Placeholder, 
          required: true,
          name: 'address2',
          defaultValue: _vm.editAddress?.address2,
          defErrorMsg: _vm.config?.requiredFieldsPrompt,
        }}}):_vm._e(),_c('div',{staticClass:"csr-account-form__field"},[(_setup.countryShow)?_c(_setup.Country,{ref:"countryInput",attrs:{"notRunInit":true,"data-conf":{ 
            label: _vm.config.address.countryLabel, 
            placeholder: _vm.config.address.countryPlaceholder, 
            required: true,
            name: 'country',
            defaultValue: _setup.countyDefaultValue,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
            disabled: true,
          }}}):_vm._e(),_c(_setup.Phone,{ref:"phoneNumberInput",attrs:{"data-conf":{ 
            label: _vm.config.address.phoneLabel, 
            placeholder: _vm.config.address.phonePlaceholder, 
            required: _setup.isMx ? true: false,
            name: 'phone',
            defaultValue: _vm.editAddress?.phone,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}})],1),_c('div',{staticClass:"csr-account-form__field"},[(_setup.stateShow)?[(_setup.provincesOptions.length > 0)?_c(_setup.StateProvince,{ref:"stateInput",attrs:{"data-conf":{ 
              label: _vm.config.address.stateLabel, 
              placeholder: _vm.config.address.statePlaceholder, 
              required: true,
              name: 'province',
              defaultValue: _vm.editAddress?.provinceCode,
              defErrorMsg: _vm.config.requiredFieldsPrompt,
              dataSource: _setup.provincesOptions
            }}}):_c(_setup.Others,{ref:"stateInput",attrs:{"data-conf":{ 
              label: _vm.config.address.stateLabel,
              placeholder: _vm.config.address.statePlaceholder, 
              required: false,
              name: 'province',
              defaultValue: _vm.editAddress?.province,
              defErrorMsg: _vm.config.requiredFieldsPrompt,
            }}})]:_vm._e(),_c(_setup.City,{ref:"cityInput",attrs:{"data-conf":{ 
            label: _vm.config.address.cityLabel, 
            placeholder: _vm.config.address.cityPlaceholder, 
            required: true,
            name: 'city',
            defaultValue: _vm.editAddress?.city,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}}),_c(_setup.PostalCode,{ref:"zipCodeInput",attrs:{"data-conf":{ 
            label: _vm.config.address.zipCodeLabel, 
            placeholder: _vm.config.address.zipCodePlaceholder, 
            required: true,
            name: 'zip',
            defaultValue: _vm.editAddress?.zip,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
            formatHint: _vm.config.address?.zipCodeFormatPrompt,
          }}})],2),(!_vm.editAddress.isDefault)?_c('MdCheckbox',{attrs:{"value":_setup.isDefaultAddress},on:{"change":_setup.handleChangeDefaultAddress}},[_c('span',{staticClass:"csr-account-form__default"},[_vm._v(" "+_vm._s(_vm.config.address.setDefaultButton)+" ")])]):_vm._e(),_c('div',{staticClass:"csr-account-form__btn-group"},[_c('button',{staticClass:"csr-account-form__btn md-button-v2 md-button md-button--primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.config.confirmButton))]),_c('button',{staticClass:"csr-account-form__btn md-button-v2 md-button md-button--black",attrs:{"type":"button"},on:{"click":() => _setup.clickCancel()}},[_vm._v(_vm._s(_vm.config.cancelButton))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }